<template>
  <auth-layout :heading="$t('heading')">
    <v-form v-model="isFormValid">
      <email-input v-model="email"/>
    </v-form>
    <v-btn
      slot="navigation"
      :to="{name: 'login'}"
      flat
    >
      {{ $t('back') }}
    </v-btn>
    <v-btn
      slot="action"
      :disabled="!isFormValid || isLoading"
      :loading="isLoading"
      color="primary"
      @click="submit"
    >
      {{ $t('send') }}
    </v-btn>

  </auth-layout>
</template>

<script>
import UserApi from '@/api/UserApi'
import EmailInput from '@/components/global-components/inputs/EmailInput.vue'
import AuthLayout from '@/components/layouts/AuthLayout'

export default {
  name: 'PasswordForgot',
  components: { AuthLayout, EmailInput },
  props: [],
  data () {
    return {
      isFormValid: false,
      email: '',
      isLoading: false
    }
  },
  methods: {
    async submit () {
      if (!this.isFormValid) return

      this.isLoading = true
      try {
        const response = await UserApi.forgotPassword(this.email)
        this.$notification(response)
      } catch (e) {
        this.$notification(e)
      }
      this.isLoading = false
    }
  },
  i18n: {
    messages: {
      de: {
        heading: 'Passwort vergessen',
        send: 'Passwort anfordern',
        back: 'Zurück'
      },
      en: {
        heading: 'Forgot password',
        send: 'Require new password',
        back: 'Back'
      },
      tr: {
        heading: 'Şifremi unuttum',
        send: 'Yeni şifre gerekli',
        back: 'Geri'
      },
      ru: {
        heading: 'Восстановление пароля',
        send: 'Отправить',
        back: 'Назад'
      }
    }
  }
}
</script>
